export default "__VITE_ASSET__CxqAr4pX__"